<div class="d-flex flex-column justify-content-center align-items-center">
  <p>{{ message | async }}</p>
</div>
